module.exports = __webpack_public_path__ + "static/media/checkliste.5050aa06.png";